import { render } from "./ImageEditorCanvas.vue?vue&type=template&id=0ea20f82&scoped=true"
import script from "./ImageEditorCanvas.vue?vue&type=script&lang=js"
export * from "./ImageEditorCanvas.vue?vue&type=script&lang=js"

import "./ImageEditorCanvas.vue?vue&type=style&index=0&id=0ea20f82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ea20f82"

export default script